import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { toRem } from '@marriott/shared/mi-helper-utils';
import type { AspectRatioCss } from './OCardLayeredStandard.utils';

export const Wrapper = styled.article<{
  $isClickable: boolean;
  $mobileAspectRatio: AspectRatioCss;
  $desktopAspectRatio: AspectRatioCss;
}>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $mobileAspectRatio }) => $mobileAspectRatio};
  overflow: hidden;
  border-radius: var(--t-cards-border-radius, 14px);
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};

  @media ${baseVariables.mediaQuery.md} {
    aspect-ratio: ${({ $desktopAspectRatio }) => $desktopAspectRatio};
  }

  &:focus-visible {
    outline: 2px solid var(--t-accent-color, #ff8d6b);
    outline-offset: 2px;
  }
`;

export const ImageContainer = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  [data-testid='web-ui-kit-AImage'] {
    display: block;
    width: 100%;
    height: 100%;
  }

  picture {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    aspect-ratio: unset;
  }
`;

export const TagOverlay = styled.div`
  position: absolute;
  inset-block-start: ${toRem(24)};
  inset-inline-start: ${toRem(24)};
  z-index: 2;
  display: flex;
`;

/** Figma: optional m-button-icon, top-right (mirrors tag inset on the opposite edge). */
export const ButtonIconOverlay = styled.div`
  position: absolute;
  inset-block-start: ${toRem(24)};
  inset-inline-end: ${toRem(24)};
  z-index: 2;
  display: flex;
`;

export const ContentSafeZone = styled.div<{ $hasLogo?: boolean }>`
  position: absolute;
  inset-block-end: 0;
  inset-inline: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ $hasLogo }) => ($hasLogo ? 0 : toRem(8))};
  align-items: flex-start;
  justify-content: flex-end;
  padding-block-end: ${toRem(20)};
  padding-inline: ${toRem(24)};
`;

export const ScrimWrapper = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const LogoWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: ${toRem(78)};
  height: ${toRem(52)};
  margin-block-end: ${toRem(8)};
`;

export const TextRow = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  gap: ${toRem(8)};
  align-items: flex-end;
  width: 100%;
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  min-width: 0;
`;

/** Figma a-icon: L (24×24); margin offsets a-body padding-block-end so icon aligns to last text line */
export const ArrowIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${toRem(24)};
  height: ${toRem(24)};
  margin-block-end: ${toRem(4)};
`;

export const TopIconWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: ${toRem(16)};
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;
